import {CustomFieldProfileItem, CustomFieldProfileItemEntity} from "../../../model/custom-field-profile-item";
import {makeEntitySelectors} from "../base-entity-store";

export interface CustomFieldProfileItemSelectorProps {

}

const customFieldProfileItemSelectors = makeEntitySelectors<
  CustomFieldProfileItem,
  CustomFieldProfileItemEntity,
  CustomFieldProfileItemSelectorProps
>({
  defaultProps: {},

  filter: (_v, _props) => true,

  transform: (value) => CustomFieldProfileItemEntity.from(value),
});

export const customFieldProfileItemsSelector =
  (props?: CustomFieldProfileItemSelectorProps) =>
    customFieldProfileItemSelectors.listSelector(props);

export const customFieldProfileItemSelector =
  () => customFieldProfileItemSelectors.singleSelector();
